<script>
import { filter, get, sortBy } from "lodash";
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { interactionMixin } from "src/modules/interactions_module.js";
import { sendFandomAnalyticsEvent } from "src/modules/fandom_analytics_module.js";

export default {
  mixins: [fandomBasicMixin, interactionMixin],
  data() {
    return {
      overvideoInteraction: null,
      videoPlayer: {},
      progressBarDragging: false,
      progressBarValue: 0,
      skipLock: false,
      mobileLandscape: false,
      overvideoInteractionAudio: null,
      showEvaluationToolCTA: false,
      evaluationToolLoadingTime: false,
      triggerPlayInteraction: true
    };
  },
  watch: {
    "videoPlayer.firstPlay"(newValue) {
      if (newValue) {
        this.playVideoCallback();
      }
    },
    // Update the progress bar
    "videoPlayer.progress"(newValue, previousValue) {
      if (!this.progressBarDragging) {
        this.progressBarValue = newValue;
      }
    },
    "videoPlayer.end"(newValue, previousValue) {
      if (newValue) {
        const event = get(globalState, ["videoPopupContent", "endEvent"], false);
        if (event) {
          Fandom.emit(event);
        }
        if (this.isEvaluationTool) {
          this.videoPlayer.pause();
          this.toggleEvaluationToolCTA();
        } else if (get(this.content, ['play', 'end_registration_modal'], false)) {
          $("#modal-registration-video-popup").modal('show');
        } else {
          this.toggleVideoPopup();
        }
      }
    },
    overvideoInteraction(newValue, oldValue) {
      if (!!newValue) {
        // this.skipLock = true;
        if (this.overvideoInteractionAudio) {
          this.overvideoInteractionAudio.currentTime = 0;
          if (!this.videoPlayer.muted) {
            this.overvideoInteractionAudio.play();
          }
        }
      } else {
        this.skipLock = false;
        if (this.overvideoInteractionAudio) {
          this.overvideoInteractionAudio.pause();
        }
      }
    },
    mobileLandscape(newVal) {
      if (!newVal) {
        if (!this.overvideoInteraction) {
          this.videoPlayer.play();
        }
      } else {
        this.videoPlayer.pause();
      }
    },
    'videoPlayer'(newVal) {
      if (newVal.getPlayerState instanceof Function && newVal.getPlayerState() == 1 && get(globalState, ["videoPopupContent", "portraitOnly"], false) && this.isViewportSmall) {
        // landscape layer handler
        // iOs supports window.orientation, other browsers support window.screen.orientation.angle
        Vue.set(this, 'mobileLandscape', !navigator.maxTouchPoints ? false : !!(window.orientation || get(window, ["screen", "orientation", "angle"], false)));
        window.addEventListener("resize", () => {
          Vue.set(this, 'mobileLandscape', !navigator.maxTouchPoints ? false : !!(window.orientation || get(window, ["screen", "orientation", "angle"], false)));
        })
        window.addEventListener("orientationchange", () => {
          Vue.set(this, 'mobileLandscape', !navigator.maxTouchPoints ? false : !!(window.orientation || get(window, ["screen", "orientation", "angle"], false)));
        })
      }
    }
  },
  mounted() {
    if (this.progressBarRef && !this.preventProgressBarEvents) {
      this.progressBarRef.addEventListener("input", this.progressInputHandler);
      this.progressBarRef.addEventListener("change", this.progressChangeHandler);
    }

    const audioUrl = get(globalState, ["videoPopupContent", "overvideoInteractionAudioUrl"], false);
    const audioVolume = get(globalState, ["videoPopupContent", "overvideoInteractionAudioVolume"], 0.5);
    if (audioUrl) {
      Vue.set(this, 'overvideoInteractionAudio', new Audio(audioUrl));
      this.overvideoInteractionAudio.loop = true;
      this.overvideoInteractionAudio.volume = audioVolume;

      // Buffering after open video popup event
      this.overvideoInteractionAudio.play();
      this.overvideoInteractionAudio.pause();
    }

    Vue.nextTick(() => {
      this.initFullscreen();
    });
  },
  computed: {
    // The component can contain a progress bar with progress-bar reference.
    progressBarRef() {
      return this.$refs["progress-bar"];
    },
    inPause() {
      return Fandom.exists(this.videoPlayer.playing) && !this.videoPlayer.playing && !this.overvideoInteraction;
    },
    isVideoInteractive() {
      return get(this.content, ["play", "videoConfig", "interactive"], false);
    },
    preventProgressBarEvents() {
      return get(this.content, ["play", "videoConfig", "preventProgressBarEvents"], false)
    },
    clickAudioUrl() {
      return get(globalState, ["videoPopupContent", "clickAudioUrl"], false);
    },
    isViewportSmall() {
      return globalState.viewport.xs;
    },
    isEvaluationTool() {
      return get(globalState, ["videoPopupContent", "evaluationTool"], false);
    }
  },
  methods: {
    isIOsMobile() {
      return /iPad/i.test(navigator.userAgent);
    },
    initFullscreen() {
      /* When the openFullscreen() function is executed, open the video in fullscreen.
      Note that we must include prefixes for different browsers, as they don't support the requestFullscreen method yet */
      if (this.$el.requestFullscreen) {
        this.$el.requestFullscreen();
      } else if (this.$el.mozRequestFullScreen) { /* Firefox */
        this.$el.mozRequestFullScreen();
      } else if (this.$el.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        this.$el.webkitRequestFullscreen();
      }

      this.$el.addEventListener("fullscreenchange", this.onFullscreenChange);
      this.$el.addEventListener("webkitfullscreenchange", this.onFullscreenChange);
      this.$el.addEventListener("mozfullscreenchange", this.onFullscreenChange);
    },
    onFullscreenChange() {
      const fullscreen = Fandom.exists(document.fullscreenElement) || 
                         Fandom.exists(document.mozFullScreenElement) || 
                         Fandom.exists(document.webkitFullscreenElement);

      if (!fullscreen) {
        this.toggleVideoPopup();
      }
    },
    // Event corresponding to the input range drag start. Together with progressChangeHandler manages the progress bar update
    progressInputHandler() {
      this.progressBarDragging = true; 
    },
    // Event corresponding to the input range drag end
    progressChangeHandler() {
      this.videoPlayer.skipToSecond(this.progressBarValue * this.videoPlayer.getDuration() / 100);
      this.progressBarDragging = false;
    },
    toggleVideoState() {
      if (this.videoPlayer.playing) {
        this.videoPlayer.pause();
      } else {
        this.videoPlayer.play();
      }
    },
    toggleVideoPopup() {
      if (!!this.overvideoInteractionAudio) {
        this.overvideoInteractionAudio.pause();
      }
      Vue.delete(globalState, "videoPopupContent");
    },
    toggleEvaluationToolCTA() {
      Fandom.post({
        url: '/api/v5/evaluation_tool/end',
        data: { content_name: this.content.name },
        success: (data) => {
          Vue.set(this, "showEvaluationToolCTA", true);
        }
      });
    },
    toggleEvaluationToolLoadingTime() {
      sendFandomAnalyticsEvent("Interaction Test", "Vai ai contenuti", "Vai ai contenuti");
      this.evaluationToolLoadingTime = true;
      const resultUrl = get(this.content, ["result_url", "url"], '/');
      Fandom.setCookie('evaluation_tool_result_url', resultUrl);
      const milliseconds = (parseInt(this.content.loading_time) || 3) * 1000;
      setTimeout(() => {
        if (Fandom.isUserRegistered()) {
          window.location.href = resultUrl;
        } else {
          this.evaluationToolLoadingTime = false;
          $("#modal-registration-video-popup").modal('show');
        }
      }, milliseconds);
    },
    chapterStatus(chapter) {
      const interactionRecord = chapter.interaction;
      if (this.isInteractionDone(this.containerContent, interactionRecord.interaction)) {
        const userInteraction = this.getUserInteraction(this.containerContent, interactionRecord.interaction);
        switch (interactionRecord.interaction.type) {
          case 'TestStep':
            return true;
          case 'Evaluate':
            return null;
          default:
            return get(userInteraction, ['data', 'answer_status'], true) ? true : false;
        }
      } else {
        return null;
      }
    },
    goToNextChapter() {
      if (!this.skipLock) {
        this.skipLock = true;
        const currentSeconds = this.videoPlayer.getCurrentTime();
        const nextChapter = sortBy(this.content.chaptering, [(c) => { return parseInt(c.seconds); }]).find(el =>  parseInt(el.seconds) > currentSeconds);
        const trackingParams = get(globalState, ["videoPopupContent", "skipGAEventParams"], false);
        if (trackingParams) {
          sendFandomAnalyticsEvent(...Object.values(trackingParams));
        }
        if (!!nextChapter) {
          this.videoPlayer.skipToSecond(nextChapter.seconds);
        } else {
          this.videoPlayer.toggleEndVideo();
        }
      }
    },
    playVideoCallback() {
      const trackingParams = get(globalState, ["videoPopupContent", "playGAEventParams"], false);
      if (trackingParams) {
        sendFandomAnalyticsEvent(...Object.values(trackingParams));
      }

      const firstPlayCallback = get(globalState, ["videoPopupContent", "firstPlayCallback"], null);
      if (typeof firstPlayCallback === "function") Fandom.executeOnce("evaluation-tool-first-play",firstPlayCallback);
    }
  }
};
</script>

<template>
  <div class="bg-dark" video-popup-component>
    <div class="video-popup__embed-container">
      <component 
        ref="embed-video"
        v-if="exists(content.play)" 
        class="embed-video d-flex justify-content-center align-items-center"
        :is="`embed-${content.play.media_type}`"  
        :content="content" 
        :opt-container-content="containerContent"
        @video-player-handler="videoPlayer = arguments[0]"
        @overvideo-interaction-handler="overvideoInteraction = arguments[0]"
      >
      </component>  
      <div v-if="isVideoInteractive" class="position-absolute-center video-popup__prevent-action"></div>
      <div v-if="isVideoInteractive" class="position-absolute-center cursor-pointer" @click="toggleVideoState()"></div>
      <div v-if="isVideoInteractive && videoPlayer.muted" class="m-3 px-2 py-1 text-white bg-dark d-flex align-items-center video-popup__unmute cursor-pointer" @click="videoPlayer.unMute()">
        <small><i class="fal fa-volume-slash mr-2"></i>umuted</small>
      </div>
    </div>

    <div
      v-if="inPause && isVideoInteractive && !showEvaluationToolCTA && !evaluationToolLoadingTime && !mobileLandscape"
      class="text-white position-absolute-center video-popup__pause d-flex align-items-center justify-content-center"
      @click="toggleVideoState()">
      <i class="fal fa-pause"></i>
    </div>

    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <component
        v-if="overvideoInteraction"
        :is="overvideoInteraction.layout"
        class="text-white bg-primary position-absolute-center video-popup__overvideo-interaction"
        :content="overvideoInteraction"
        :click-audio-url="clickAudioUrl"
        :opt-container-content="containerContent"
        @interaction-done="$refs['embed-video'].unsetOvervideoInteraction()"
      ></component>
    </transition>
    
    <template>
      <div v-if="isVideoInteractive" v-show="exists(videoPlayer.playing)" class="video-popup__progress-bar d-flex align-items-center">
        <input v-if="!isEvaluationTool" ref="progress-bar" type="range" step="0.001" min="0" max="100" v-model="progressBarValue" class="video-popup__progress-bar-input">
        <div class="video-popup__progress-wrapper">
          <div class="video-popup__progress" :class="{'bg-gray-600': isEvaluationTool}" :style="{'width': `${progressBarValue}%`}"></div>
          <div class="video-popup__progress-background"></div>
        </div>
        <div
          class="video-popup__progress-bar-chapter d-flex align-items-center justify-content-center"
          v-for="(chapter, index) in content.chaptering"
          :key="`chapter-${index}`"
          :style="{left: `calc(${chapter.position} - ${isViewportSmall ? 12 : 16}px)`}"
          :class="{'active': chapter.active, 'wrong': chapterStatus(chapter) == false, 'correct': chapterStatus(chapter) == true}"
          @click="() => {
            if (!preventProgressBarEvents) {
              videoPlayer.skipToSecond(chapter.seconds)
            }
          }"
          >
          <i
            v-if="!chapter.icon"
            class="far"
            :class="{'fa-question': !exists(chapterStatus(chapter)), 'fa-thumbs-down': chapterStatus(chapter) == false, 'fa-thumbs-up': chapterStatus(chapter) == true}"
          ></i>
          <img v-else :src="chapter.icon.url" class="img-fluid"/>
        </div>
        <button
          class="btn btn-primary btn-next-chapter d-flex align-items-center text-uppercase"
          :class="{'disabled': skipLock}"
          :disabled="skipLock"
          @click="goToNextChapter()"
          v-if="preventProgressBarEvents"
        >
          {{ft('globals.video_popup.skip')}}<i class="fal ml-2 fa-forward"></i>
        </button>
      </div>
    </template>

    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <div v-if="mobileLandscape" class="p-4 landscape-layer d-flex flex-column justify-content-center align-items-center position-absolute-center text-white">
        <i class="far fa-4x fa-sync"></i>
        <div class="h3 mb-0 pt-3 text-center font-weight-bold">{{ft('globals.video_popup.flip_device')}}</div>
      </div>
    </transition>

    <!-- START evaluation tool waiting layer and registration modal -->
    <div v-if="isEvaluationTool">
      <transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster">
        <div class="position-absolute-center video-popup__overvideo-interaction bg-primary p-4 p-md-5 d-flex justify-content-center align-items-center flex-column text-white" v-if="showEvaluationToolCTA">
          <h2 class="text-center font-weight bold">{{ft('globals.video_popup.evaluation_tool.results_title')}}</h2>
          <h3 class="text-center">{{ft('globals.video_popup.evaluation_tool.results_subtitle')}}</h3>
          <button class="btn btn-outline-light mt-4 px-5 py-4" @click="toggleEvaluationToolLoadingTime">
            {{ft('globals.video_popup.evaluation_tool.results_button')}}
          </button>
        </div>
      </transition>
      <transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster">
        <div class="bg-primary video-popup__overvideo-interaction position-absolute-center p-4 p-md-5 d-flex flex-column justify-content-center align-items-center text-white" v-if="evaluationToolLoadingTime && content.loading_gif">
          <img :src="content.loading_gif.url" />
          <h4 class="text-center mt-4">{{ft('globals.video_popup.evaluation_tool.loading_title')}}</h4>
        </div>
      </transition>
    </div>
    <!-- END evaluation tool waiting layer and registration modal -->

    <div id="modal-registration-video-popup" :class="{'modal-layer': !isEvaluationTool}" class="modal fade" tabindex="-1" role="dialog" v-if="content.registration_required_modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header border-bottom-0 px-2 px-md-3 py-2 pb-md-0 pt-md-3">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center px-4 px-md-5 pb-5 pt-0 pt-md-4">
            <div class="row justify-content-center">
              <div class="col-12 d-flex align-items-center mb-3" v-if="content.registration_required_modal.image">
                <img :src="content.registration_required_modal.image.url" class="w-100"/>
              </div>
              <div class="col-12">
                <h3 class="font-weight-light text-gray-900" v-if="content.registration_required_modal.title">
                  {{content.registration_required_modal.title}}
                </h3>
                <div class="font-weight-normal text-gray-900 small mb-4 pb-md-3" v-if="content.registration_required_modal.description">
                  {{content.registration_required_modal.description}}
                </div>
                <a href="/users/sign_up" class="btn btn-primary mb-3 d-block">{{ft('globals.register_now')}}</a>
                <span class="py-2 d-block small text-dark" v-html="ft('globals.already_registered')"></span>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </div>

    <div v-if="!isIOsMobile()" class="video-popup__close d-flex justify-content-center align-items-center" @click.stop="toggleVideoPopup()">
      <i class="fal fa-times"></i>
    </div>

  </div>
</template>

<style lang="scss" scoped>
@mixin thumb-styles($selector) {
  #{$selector}::-webkit-slider-thumb {
    @content
  }
  #{$selector}::-moz-range-thumb {
    @content
  }
  #{$selector}::-ms-thumb {
    @content
  }
}

[video-popup-component] {
  $progress-icon-size: 2rem;
  $video-progress-bar-marker-size: 2rem;
  $bar-height: .375rem;

  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1090;
  height: 100vh;

  .video-popup__unmute {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1050;
  }

  .embed-video {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;

    ::v-deep > div, ::v-deep iframe {
      width: 100%;
      height: 100%;

      @include media-breakpoint-down(xs) {
        height: 177.78vw;
        width: 56.25vh;
        left: 50%;
        min-height: 100%;
        min-width: 100%;
        transform: translate(-50%, -50%);
        top: 50%;
        position: absolute;
      }
    }
  }

  .video-popup__overvideo-interaction {
    z-index: 1;
  }

  .video-popup__prevent-action {
    background-color: transparent;
  }

  .video-popup__progress-wrapper {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: $bar-height;
    border-radius: .25rem;
  }

  .video-popup__progress {
    width: 101%;
    height: 100%;
    position: absolute;
    top: 0;
    background: $primary;
  }
  
  .video-popup__progress-background {
    width: 100%;
    height: 100%;
    background-color: $white;
    border: 1px solid $gray-200;
  }

  .video-popup__pause i {
    @include font-size(5rem);
  }

  .video-popup__close {
    z-index: 1;
    top: .75rem;
    right: .75rem;
    width: 1.5rem;
    height: 1.5rem;
    color: $white;
    cursor: pointer;
    font-size: 2rem;
    line-height: 1;
    position: absolute;
  }

  .video-popup__embed-container {
    height: 100vh;
    position: relative;
  }

  .video-popup__progress-bar {
    position: fixed;
    bottom: 35px;
    margin: 0 auto;
    left: 0;
    right: 0;
    width: 75%;

    .btn-next-chapter {
      position: absolute;
      bottom: calc(100% + 1rem);
      right: 0;
    }

    .video-popup__progress-bar-input {
      width: 100%;
      appearance: none;
      height: $bar-height * 6;
      outline: none;
      position: absolute;
      top: -$bar-height * 3;
      left: 0;
      background-color: transparent;
      z-index: 1;

      @include thumb-styles("&") {
        appearance: none;
        width: $video-progress-bar-marker-size / 2;
        height: $video-progress-bar-marker-size / 2;
        border-radius: 100%;
        border: none;
        bottom: -$bar-height / 2;
        background: $primary !important;
        cursor: pointer;
        position: relative;
        z-index: 3;
      }
    }

    .video-popup__progress-bar-chapter {
      position: absolute;
      top: unset;
      width: $video-progress-bar-marker-size;
      height: $video-progress-bar-marker-size;
      background-color: $primary;
      border: 1px solid $primary;
      color: $white;
      border-radius: 100%;
      cursor: pointer;
      z-index: 2;

      .far {
        @include font-size($video-progress-bar-marker-size * 0.5);
      }

      &.active {
        // background-color: $gray-300;
        background-color: $white;
        border: 0 solid $primary;
        box-shadow: 0 0 0 $video-progress-bar-marker-size * 0.175 inset $primary;
      }

      &.correct {
        background-color: $success;
        border-color: $success;
      }

      &.wrong {
        background-color: $danger;
        border-color: $danger;
      }
    }
  }

  ::v-deep [embed-kaltura-component] > div {
    height: 100vh;
  }

  @include media-breakpoint-down(sm) {

    .video-popup__progress-bar {

      .video-popup__progress-bar-input {
        @include thumb-styles("&") {
          width: $video-progress-bar-marker-size * 0.75 + .115rem;
          height: $video-progress-bar-marker-size * 0.75 + .115rem;
        }
      }

      .video-popup__progress-bar-chapter {
        width: $video-progress-bar-marker-size * 0.75;
        height: $video-progress-bar-marker-size * 0.75;
        .far {
          @include font-size($video-progress-bar-marker-size * 0.30);
        }
      }
    }
  }

  .video-popup__pause,
  .landscape-layer {
    background-color: rgba(0,0,0,0.75);
    z-index: 1;
  }

  .modal-layer {
    background-color: rgba(0,0,0,0.5);
  }

  .landscape-layer {
    display: none;
  }
}
</style>
